import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Sidebar.module.css';

interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}

interface MenuItem {
  label: string;
  path?: string;
  children?: MenuItem[];
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});

  const menuItems: MenuItem[] = [
    {
      label: t('SideMenu.Labels.Items'),
      children: [
        { label: t('SideMenu.Labels.AllItems'), path: '/items' },
        { label: t('SideMenu.Labels.CreateItem'), path: '/items/create' },
      ],
    },
  ];

  const toggleCategory = (label: string) => {
    setExpanded(prev => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
      <nav>
        <ul className={styles.navList}>
          {menuItems.map((item) => (
            <li key={item.label} className={styles.category}>
              {item.children ? (
                <>
                  <div
                    className={styles.categoryHeader}
                    onClick={() => toggleCategory(item.label)}
                  >
                    {item.label}
                    <span className={styles.arrow}>
                      {expanded[item.label] ? '▲' : '▼'}
                    </span>
                  </div>
                  <ul className={`${styles.subMenu} ${expanded[item.label] ? styles.openSubMenu : ''}`}>
                    {item.children.map(child => (
                      <li key={child.label}>
                        <NavLink
                          to={child.path || '#'}
                          className={({ isActive }) =>
                            isActive ? styles.activeLink : ''
                          }
                          onClick={onClose}
                        >
                          {child.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <NavLink
                  to={item.path || '#'}
                  className={({ isActive }) =>
                    isActive ? styles.activeLink : ''
                  }
                  onClick={onClose}
                >
                  {item.label}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;

